(function ($, Drupal, once, drupalSettings) {
  Drupal.behaviors.mainHeader = {
    attach: function (context, settings) {
      once('mainHeader', '.main-header', context).forEach(function (block) {

        var lastScrollTop = 0;

        $(window).scroll(function (e) {
          if ($(window).scrollTop() > 60) {
            $('body').addClass('scrolled');
            $(block).addClass('scrolled');
          } else {
            $('body').removeClass('scrolled');
            $(block).removeClass('scrolled');
          }

          var st = $(this).scrollTop();
          if (st > lastScrollTop) {
            $(block).removeClass('scrollUp').addClass('scrollDown');
          } else {
            $(block).removeClass('scrollDown').addClass('scrollUp');
          }
          lastScrollTop = st;
        });
      });


      if ($('.banner').attr('data-bg') !== undefined) {
        $('body').addClass('has-banner');
      } else {
        $('body').addClass('has-no-banner');
      }

      once('menu', '.main-header', context).forEach(function (block) {
        $(document).on('click', ".toggle-menu", function (e) {
          e.preventDefault();
          $(this).toggleClass('open');
          $(this).hasClass('open') ? $(this).attr('aria-expanded', 'true') : $(this).attr('aria-expanded', 'false');
          $('body').toggleClass('menu-open');
        });

        $(".menu-wrapper").each(function () {
          var el = $(this).find("a, span");
          var elActive = $(this).find("a.is-active");

          elActive.parent("li").addClass("active");
          elActive.parent("li").parents("li").addClass("active-trail");

          if ($(this).children("ul").find("ul").length) {
            $(this).children("ul").addClass("sublvl");
          }

          el.each(function () {
            if ($(this).next("ul").length) {
              $(this).after('<button aria-expanded="false" class="expand"></button>');
            }
          });
        });

        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          deviceEventType = 'touchstart'
        } else {
          deviceEventType = 'click'
        }

        $(document).on(deviceEventType, ".menu-wrapper .expand", function () {
          $(this).parent("li").toggleClass('open');
          $(this).parent("li").hasClass('open') ? $(this).attr("aria-expanded", "true") : $(this).attr("aria-expanded", "false");
        });

        $(document).on(deviceEventType, ".menu-wrapper span", function () {
          $(this).parent("li").toggleClass('open');
          $(this).parent("li").hasClass('open') ? $(this).attr("aria-expanded", "true") : $(this).attr("aria-expanded", "false");
        });

        $(".menu-wrapper > ul > li").each(function () {
          $(this).on("mouseenter", function () {
            $(".menu-wrapper > ul > li").removeClass('hovered');
            $(this).addClass('hovered');
          });
        });

        $(".main-header").on("mouseleave", function () {
          $(".menu-wrapper > ul > li").removeClass('hovered');
        });
      });
    }
  }
})(jQuery, Drupal, once, drupalSettings);
